import { Box, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      textAlign="center"
    >
      <Stack spacing={2} alignItems="center">
        <Typography variant="h2" color="error">
          404
        </Typography>
        <Typography variant="h5">
          Oops! The page you are looking for does not exist.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate("/")}>
          Go to Home
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFoundPage;
